<template>
  <div>
    <Header
      :headerTitle="$t('m.invoiceDetails.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>
    <header>
      <ul>
        <div class="invocingInfoTitle">{{$t('m.invoiceDetails.sonTitle1')}}</div>
        <li>
          <strong>{{$t('m.invoiceDetails.emailTilte')}}</strong>
          <span>{{listInvoice.email}}</span>
        </li>
        <div class="invocingInfoTitle">{{$t('m.invoiceDetails.title')}}</div>
        <li>
          <strong>{{$t('m.invoiceDetails.invoiceTitle')}}</strong>
          <span>{{listInvoice.businessName}}</span>
        </li>

        <li v-if="listInvoice.type==2">
          <strong>{{$t('m.invoiceDetails.codeTitle')}}</strong>
          <span>{{listInvoice.businessNumber}}</span>
        </li>
        <li>
          <strong>{{$t('m.invoiceDetails.contextTitle')}}</strong>
          <span>{{listInvoice.contents}}</span>
        </li>
        <li>
          <strong>{{$t('m.invoiceDetails.amountTilte')}}</strong>
          <span>{{listInvoice.amount}}{{$t('m.invoiceDetails.CNY')}}</span>
        </li>
        <li>
          <strong>{{$t('m.invoiceDetails.createDate')}}</strong>
          <span>{{listInvoice.createTime}}</span>
        </li>
        <div class="invocingInfoTitle" style="height:12px;"></div>
        <li class="order">
          <strong v-if="$t('m.invoiceDetails.language')=='zh_CN'">含{{countOrder}}个订单</strong>
          <strong v-else>{{countOrder}} orders included</strong>
          <span>
            <a @click="selectOrderByInvoice(listInvoice.orderIds)">{{$t('m.invoiceDetails.view')}}</a>
          </span>
        </li>
      </ul>
    </header>
    <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { invoiceInfoById } from "../../api/invoice.js";
export default {
  name: "invoiceDetails",
  data() {
    return {
      isCarInvoicingRequired: "", //是否有其他订单
      listInvoice: {}, //数据
      countOrder: 0, //查看多少个相关订单
      id: "", //id
      phone: "400-115-0606", //电话
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //页面加载的数据
    loadOrdetInfoById: function() {
      invoiceInfoById({ id: this.id }).then(
        response => {
          if (response.data.status == 200) {
            this.listInvoice = response.data.result.invoice;
            this.countOrder = this.listInvoice.orderIds.split(",").length;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //查询操作
    selectOrderByInvoice: function(orderIds) {
      this.$router.push("/orderList/" + orderIds);
    },
    call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  //加载事件
  created() {
    this.id = this.$route.params.id; //订单Id
    this.loadOrdetInfoById();
  }
};
</script>
<style scoped>
header {
  margin: 0 auto;
  padding: 0px;
}

header .invocingInfoTitle {
  background-color: #f5f5f5;
  color: #a7a5a0;
  font-size: 14px;
  text-align: left;
  padding-left: 15px;
  line-height: 33px;
}
header ul {
  padding-inline-start: 0px;
}
header li {
  list-style: none;
  border-bottom: 1px solid #e7e7e7;
  padding: 4px 15px;
}
header strong {
  font-size: 14px;
  font-family: "宋体";
  display: inline-block;
  float: left;
  padding-top: 5px;
  width: 20%;
  text-align: left;
  color: #5c5b5b;
}
header ul li span {
  text-align: left;
  display: inline-block;
  width: 72%;
  font-size: 14px;
  color: #2e2e2e;
}
header ul .order strong {
  width: 60%;
}
header ul .order span {
  width: 40%;
  text-align: right;
}
</style>
